export const FILTER_ALL_VALUE = 'ALL';

export enum FilterContentFieldDataTypes {
  NUMBER = 'number',
  DATE = 'date',
  STRING = 'string',
  LIST = 'list'
}

export const NUMBER_OPERATORS = [
  {
    label: 'Greater than or Equals',
    value: 'GREATER_THAN_OR_EQUALS'
  },
  {
    label: 'Greater than',
    value: 'GREATER_THAN'
  },
  {
    label: 'Lesser than or Equals',
    value: 'LESSER_THAN_OR_EQUALS'
  },
  {
    label: 'Lesser than',
    value: 'LESSER_THAN'
  },
  {
    label: 'Equals',
    value: 'EQUALS'
  },
  {
    label: 'Not Equals',
    value: 'NOT_EQUALS'
  }
];

export const STRING_OPERATORS = [
  { label: 'Exact Match', value: 'EXACT_MATCH' },
  {
    label: 'Contains',
    value: 'CONTAINS'
  },
  { label: 'Starts With', value: 'STARTS_WITH' },
  { label: 'Ends With', value: 'ENDS_WITH' },
  { label: 'Regex', value: 'REGEX' }
];

export const DEFAULT_STRING_OPERATOR = STRING_OPERATORS[1];

export const DATA_TYPE_OPERATOR_MAP = {
  [FilterContentFieldDataTypes.NUMBER]: NUMBER_OPERATORS
};
